<template>
  <div v-if="selectedGroup !== null" class="userinformations">
    <h3>{{ selectedGroup.name }}'s Einstellungen</h3>

    <div class="groupinformations-grid">
      <GroupInformationComponent title="Gruppenname" :content="selectedGroup.name" />
      <GroupInformationComponent
        title="Gruppenberechtigungen"
        :content="selectedGroup.permissions.join(', ').replace(/[\[\]]+/g, '')"
      />
      <GroupInformationComponent title="Gruppengewichtung" :content="selectedGroup.weight" />
    </div>
  </div>
</template>

<script>
import router from '../router/index.js'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import FloatLabel from 'primevue/floatlabel'
import InputSwitch from 'primevue/inputswitch'
import CreateUserDialog from './CreateUserDialog.vue'
import ConfirmPopup from 'primevue/confirmpopup'
import { RouterLink, useRouter } from 'vue-router'
import { getAuth, sendPasswordResetEmail } from 'firebase/auth'
import axios from 'axios'
import { config } from '../assets/config.js'
import UserInformationComponent from './UserInformationComponent.vue'
import { useAuthStore } from '@/stores/auth.js'
import GroupInformationComponent from '@/components/GroupInformationComponent.vue'

export default {
  components: {
    GroupInformationComponent,
    Dialog,
    Button,
    FloatLabel,
    InputText,
    InputSwitch,
    ConfirmPopup,
    UserInformationComponent
  },

  props: {
    selectedGroup: Object
  },

  data() {
    return {
      authStore: useAuthStore(),

      dateOptions: {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',

        second: '2-digit',
        minute: '2-digit',
        hour: '2-digit'
      }
    }
  },

  async mounted() {}
}
</script>
<style lang="scss" scoped>
.groupinformations {
  &-grid {
    display: grid;
    grid-template-columns: 33% 33% 33%;
    gap: 0.7rem;
    padding: 0 0 1rem 0;
  }
}
</style>
